import React, { useState, useContext, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faTachometerAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../auth/AuthContext';
import './Navigation.css';

const DesktopMenu = () => {
    const { auth, logout } = useContext(AuthContext);
    const [accountMenuOpen, setAccountMenuOpen] = useState(false);
    const menuRef = useRef(null);
    
    // Close the account menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setAccountMenuOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuRef]);
    
    const toggleAccountMenu = () => {
        setAccountMenuOpen(!accountMenuOpen);
    };
    
    const handleLogout = () => {
        logout();
        setAccountMenuOpen(false);
    };
    
    return (
        <div className="desktop-menu">
            <div className="Title">
                <Link to="/" className="nav-title-link">
                    <h1>Connexierge</h1>
                </Link>
            </div>
            
            <ul className="nav-links">
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/buyers">Buyers</Link>
                </li>
                <li>
                    <Link to="/sellers">Sellers</Link>
                </li>
                {!auth && (
                    <>
                        <li className="auth-button-container">
                            <Link to="/login" className="auth-button login-button">
                                Login
                            </Link>
                        </li>
                        <li className="auth-button-container">
                            <Link to="/register" className="auth-button signup-button">
                                Sign Up
                            </Link>
                        </li>
                    </>
                )}
                {auth && (
                    <li className="account-menu-container" ref={menuRef}>
                        <button 
                            className={`account-button ${auth ? 'logged-in' : ''}`}
                            onClick={toggleAccountMenu}
                            aria-label="Account menu"
                        >
                            <FontAwesomeIcon icon={faUser} />
                        </button>
                        
                        {accountMenuOpen && (
                            <div className="account-dropdown">
                                <Link to="/profile" onClick={() => setAccountMenuOpen(false)}>
                                    <FontAwesomeIcon icon={faUser} /> Profile
                                </Link>
                                <Link to="/dashboard" onClick={() => setAccountMenuOpen(false)}>
                                    <FontAwesomeIcon icon={faTachometerAlt} /> Dashboard
                                </Link>
                                <button onClick={handleLogout}>
                                    <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                                </button>
                            </div>
                        )}
                    </li>
                )}
            </ul>
        </div>
    );
};

export default DesktopMenu; 